import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { MainLayout } from './layouts/MainLayout';
import { CampaignDetailPage } from './pages/campaigns/CampaignDetail';
import { CampaignListPage } from './pages/campaigns/CampaignList';
import { DashboardPage } from './pages/dashboard/Dashboard';
import { LoginPage } from './pages/login/Login';
import { ProfilePage } from './pages/profile/Profile';
import { ProfilePointsPage } from './pages/profile/ProfilePoints';
import { ProfileRebindPage } from './pages/profile/ProfileRebind';
import { ProfileWhatsAppAccountsPage } from './pages/profile/ProfileWhatsAppAccounts';
import { ProfileWhatsAppAccountCreatePage } from './pages/profile/ProfileWhatsAppAccountCreate';
import { ReferralPage } from './pages/referral/Referral';
import { RegisterPage } from './pages/register/Register';
import { CustomerServicePage } from './pages/customer-service/CustomerService';
import { DownloadPage } from './pages/download/Download';
import { DownloadDetailPage } from './pages/download/DownloadDetail';
import { ManualActivityPage } from './pages/manual-activity/ManualActivity';
import { useAuthStore } from './stores/auth.store';

export const App: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/register" element={isAuthenticated ? <Navigate to="/" replace /> : <RegisterPage />} />
      <Route path="/download" element={<DownloadPage />} />
      <Route path="/download/detail" element={<DownloadDetailPage />} />
      <Route path="/detail" element={<DownloadDetailPage />} />
      <Route
        element={
          <ProtectedRoute allowedRoles={['promoter']}>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="/manual-activity" element={<ManualActivityPage />} />
        <Route path="/campaigns" element={<CampaignListPage />} />
        <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="/referral" element={<ReferralPage />} />
        <Route path="/customer-service" element={<CustomerServicePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/points" element={<ProfilePointsPage />} />
        <Route path="/profile/rebind" element={<ProfileRebindPage />} />
        <Route path="/profile/whatsapp-accounts" element={<ProfileWhatsAppAccountsPage />} />
        <Route path="/profile/whatsapp-accounts/new" element={<ProfileWhatsAppAccountCreatePage />} />
      </Route>
      <Route path="*" element={<Navigate to={isAuthenticated ? '/' : '/login'} replace />} />
    </Routes>
  );
};
